import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  OrderResponse,
  OrderResponseItem,
  OrderService,
} from 'src/app/services/order/order.service';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.css'],
})
export class OrderConfirmationComponent implements OnInit {
  order: any = null;
  isLoading = false;
  orderId: string | null = null;

  constructor(
    private router: Router,
    private orderService: OrderService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.orderId = this.route.snapshot.paramMap.get('id');
    if (this.orderId) {
      this.orderService.getUserOrder(this.orderId).subscribe({
        next: (res) => {
          this.order = res;
        },
      });
    }
  }

  get discount(): number {
    return Math.max(0, (this.order?.subtotal ?? 0) - (this.order?.total ?? 0));
  }

  goHome() {
    this.router.navigateByUrl('/home');
  }

  goShopping() {
    this.router.navigateByUrl('/products');
  }

  formatDate(iso: string): string {
    const d = new Date(iso);
    return (
      d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }) +
      ' ' +
      d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
    );
  }

  trackByItem(_: number, item: OrderResponseItem): string {
    return item.productId;
  }
}
